















































































import { Component, Prop, Vue } from "vue-property-decorator";
import AnxButton from "../AnxButton/AnxButton.vue";

/**
 * This component is used for generating dynamic modals.
 * Modals are dialogs that can be used to display information for users.
 */
@Component({
  components: {
    AnxButton
  }
})
export default class AnxModal extends Vue {
  /** This is the title of the modal */
  @Prop({ default: "Enter a title for the modal" }) title!: string;

  /** Defines whether the modal has a close button or not */
  @Prop({ default: null }) hasCloseButton!: boolean | null;

  /** This is the text for the close button */
  @Prop({ default: "Close" }) closeButtonText!: string;

  /**
   * This is the align for the close button. Note: This will only work, if the modal is not confirmable
   *
   * @values left, center, right
   */
  @Prop({ default: "center" }) closeButtonAlign!: string;

  /** Show confirmation modal. A 'close' or a 'confirm' event will be emitted, depending on the user input */
  @Prop({ default: null }) confirm!: boolean | null;

  /** If the confirm option is true, this is the text for the confirm button */
  @Prop({ default: "Confirm" }) confirmButtonText!: string;

  /** The id for the modal, will be set to a unique value when null */
  @Prop({ default: null }) id!: string | null;

  /**
   * The size of the model
   *
   * @values s, m, l, xl, xxl
   */
  @Prop({ default: "m" }) size!: string;

  /** This is the number of currently opened modals */
  private static numberModalsOpened = 0;

  /** This is the layer of our modal (necessary for displaying modals inside of modals) */
  private modalLayer = 0;

  /** Add event listeners for click event on mount */
  private mounted() {
    /** Increase the number of opened modals and store the current layer of our modal*/
    this.modalLayer = ++AnxModal.numberModalsOpened;

    this.updateStyles();
  }

  /** Check if the id is set otherwise create a unique id */
  private get _id() {
    if (this.id !== null) {
      return this.id;
    }

    return "anx-modal-" + AnxModal.numberModalsOpened;
  }

  /** Decrease the number of opened modals */
  private beforeDestroy() {
    if (AnxModal.numberModalsOpened > 0) AnxModal.numberModalsOpened--;

    this.updateStyles();
  }

  /** Check if the modal should be closed by the click */
  private checkForClosing(e: MouseEvent) {
    /** Check if the click was outside the modal */
    if (e.target == this.$refs["anxModalOutsideContainer"]) {
      /** Only close the modal if the current modal is in front */
      if (this.modalLayer == AnxModal.numberModalsOpened) {
        this.$emit("close");
      }
    }
  }

  /**
   * If a modal is opened, the styles of the body have to be updated
   * so that the background does not scroll
   */
  private updateStyles() {
    const body = document.body;

    // Check if there are any modals opened and add or remove the class for scrolling to the body
    if (AnxModal.numberModalsOpened > 0) {
      body.classList.add("anx-modal-is-open");
    } else {
      body.classList.remove("anx-modal-is-open");
    }
    return;
  }
}
